import { Action } from '@ngrx/store';


export enum ListaLayersActionTypes {
  LAYERS_SET = '[LAYERS] GET_LAYERS'
}

export class SETListaLayers implements Action {
  readonly type = ListaLayersActionTypes.LAYERS_SET;
  constructor(public ListaLayers: Map<string, number> ) {}
}


export type ListaLayersAcciones =
  | SETListaLayers;
